import { render, staticRenderFns } from "./NonMedicalInfoForm.vue?vue&type=template&id=3d3a2160"
import script from "./NonMedicalInfoForm.vue?vue&type=script&lang=js"
export * from "./NonMedicalInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports